import React from 'react';
import { Panel, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import NewButton from '../../common/components/NewButton';
import ui from '../../common/services/ui';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faEye } from '@fortawesome/free-regular-svg-icons';

const List = ({ isReadonly, t, ...rest }) => {
	const columns = [
		{
			header: t('Grade_Name'),
			accessor: 'name',
			sortable: true
		},
		{
			header: t('Common_Center'),
			accessor: 'center.name',
			sortable: true
		},
		{
			header: t('Grade_Mixed'),
			accessor: 'mixed',
			sortable: true,
			cell: (mixed) => (ui.formatBoolean(mixed))
		},
		{
			header: t('Grade_MaxChildren'),
			accessor: 'maxChildren',
			sortable: true
		},
		{
			header: t('Grade_IsOnline'),
			accessor: 'isOnline',
			sortable: true,
			cell: (isOnline) => (ui.formatBoolean(isOnline))
		},
		{
			header: t('Common_Actions'),
			accessor: 'id',
			cell: (id, row) => (<Link to={`/grades/${id}`} className='btn btn-teal'><FontAwesomeIcon icon={row.isReadonly ? faEye : faEdit} /> {t(row.isReadonly ? 'Common_View' : 'Common_Edit')}</Link>)
		}
	];

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} listActions={!isReadonly && <NewButton newItemPath='/grades/new' />} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);